import config from '../config';
import { request } from '../utils/request';
const contentDomain = `${config.host}${config.apiRouter.content}`;

const api = {
  getNavigationList () {
    return request({
      method: 'GET',
      url: `${contentDomain}navigation/list`,
    });
  },
  updateNavigation (data) {
    return request({
      method: 'POST',
      url: `${contentDomain}navigation/saveNavigation`,
      data,
    });
  },
  getArticleContent (data) {
    return request({
      method: 'POST',
      url: `${contentDomain}navigation/getArticleContent`,
      data,
    });
  },
  saveContent (data) {
    return request({
      method: 'POST',
      url: `${contentDomain}navigation/saveContent`,
      data,
    });
  },
  publish () {
    return request({
      method: 'POST',
      url: `${contentDomain}navigation/release`,
    });
  },
};
export default api;
